import React from 'react';
import { UI_THEME } from '../../config/constants';

interface FormFieldProps {
  id: string;
  label: string;
  type?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  helpText?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  borderColor?: string;
  focusBorderColor?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  helpText,
  error,
  required = false,
  disabled = false,
  maxLength,
  borderColor = UI_THEME.colors.gray[300],
  focusBorderColor = UI_THEME.colors.primaryFocus,
}) => {
  return (
    <div style={{ marginBottom: UI_THEME.spacing.lg }}>
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: UI_THEME.fontSize.base,
          fontWeight: UI_THEME.fontWeight.medium,
          color: UI_THEME.colors.gray[700],
          marginBottom: UI_THEME.spacing.sm
        }}
      >
        {label} {required && '*'}
      </label>

      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        maxLength={maxLength}
        style={{
          width: '100%',
          padding: UI_THEME.spacing.md,
          border: `2px solid ${error ? UI_THEME.colors.error : borderColor}`,
          borderRadius: UI_THEME.borderRadius.sm,
          fontSize: UI_THEME.fontSize.base,
          backgroundColor: disabled ? UI_THEME.colors.background.secondary : '#fdfbff',
          color: UI_THEME.colors.gray[800],
          transition: 'border-color 0.2s ease',
          outline: 'none',
          boxSizing: 'border-box'
        }}
        placeholder={placeholder}
        onFocus={(e) => {
          if (!error) {
            e.target.style.borderColor = focusBorderColor;
          }
        }}
        onBlur={(e) => {
          if (!error) {
            e.target.style.borderColor = borderColor;
          }
        }}
      />

      {helpText && !error && (
        <p style={{
          fontSize: UI_THEME.fontSize.sm,
          color: UI_THEME.colors.gray[500],
          marginTop: UI_THEME.spacing.xs
        }}>
          {helpText}
        </p>
      )}

      {error && (
        <p style={{
          fontSize: UI_THEME.fontSize.sm,
          color: UI_THEME.colors.error,
          marginTop: UI_THEME.spacing.xs
        }}>
          {error}
        </p>
      )}
    </div>
  );
};